import { render, staticRenderFns } from "./public-transport.vue?vue&type=template&id=989199d2&"
import script from "./public-transport.vue?vue&type=script&lang=js&"
export * from "./public-transport.vue?vue&type=script&lang=js&"
import style0 from "./public-transport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports